import React, { useEffect, useState } from "react";
import Candidates from "./Candidates";
import ScheduledCandidates from "./ScheduledCandidates";
import { Drawer } from "antd";
import svg85 from "../../../../../../assets/svg/svg85.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../../../../../features/dropdown/dropdownSlice";
import { setSelectedCandidates } from "../../../../../../features/folder/folderSlice";

function BlockDrawer({
  onClose,
  openDrawer,
  prodd, 
}) {
  const dispatch = useDispatch();
  const url = "api/v1/applications/filter";
  const { loading, data, count, activeObjActivity } = useSelector((state) => ({
    loading: state.dropdown.loading,
    data: state.dropdown.data[url] || [],
    count: state.dropdown.count[url] || 0,
    activeObjActivity: state.folder.activeObj["activity"],
  }));
   

const {rowId,selectedCandidates} =  useSelector((state)=>state.folder)  
  const handleUpdate = async () => {
    await dispatch(setSelectedCandidates(rowId)); 
    await onClose();
  };

  const [currentSession, setCurrentSession] = useState(prodd?.mbiName);

  async function fetchTableData() {
    await dispatch(
      fetchData({
        url: url,
        limit: null,
        start: 0,
        jobId:activeObjActivity?.jaaJobId, 
        progressStatuses: null,
        japIds: rowId?.map((item) => item?.japId),
      })
    );
  }

  // useEffect(() => {
  //   console.log("outide")
  //   fetchTableData();
  // }, []);

  useEffect(() => {
    setCurrentSession(prodd?.mbiName);
  }, [prodd]);
  return (
    <>
      <Drawer
        width={1050}
        title="Session Setting"
        open={openDrawer}
        onClose={onClose}
        closable={true}
        closeIcon={null}
        extra={
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "1.25rem",
              color: "#FFF",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        }
      >
        <div className="flex lg:flex-row flex-col lg:items-center justify-between">
          <div className="flex flex-col gap-[.1rem] font-dmSans">
            <div className="text-[#000] text-[1.5rem] font-[600] ">
              {prodd?.mbiName}
            </div>
            <div className="text-[#000] text-[.875rem] font-[400]">
              {prodd?.mbiStartTime} - {prodd?.mbiEndTime}
            </div>
          </div>

          <div className="w-[130px]">
            <button className="cstm-btn " type="button" onClick={handleUpdate}>
              Update
            </button>
          </div>
        </div>
        <ScheduledCandidates 
          currentSession={currentSession} 
        />
        <Candidates 
          prodd={prodd}
          openDrawer={openDrawer} 
        />
      </Drawer>
    </>
  );
}

export default BlockDrawer;
